import { useGoogleAnalytics } from 'libs/analytics/useGoogleAnalytics';

export default function GoogleAnalytics() {
  useGoogleAnalytics();

  return null;
}
